import * as apiClient from '../../services/api-client';

export const getAuthToken = async (store, authData) => {
    const auth = await apiClient.auth.getToken(authData);
    if(typeof auth === 'string') {
        let notification = {
            place: 'tc',
            message: 'Invalid Credentials. Please try again.',
            type: 'danger',
            icon: "now-ui-icons ui-1_bell-53",
            autoDismiss: 7
        }; 

        store.setState({ notification });
        return;
    }
    console.log('NEW AUTH TOKEN', auth);
    window.localStorage.setItem('auth', JSON.stringify(auth));
    store.setState({ auth });
};

export const getFbAuthToken = async (store, fbTokenData) => {
    const auth = await apiClient.auth.getFbToken(fbTokenData);
    if(typeof auth === 'string') {
        let notification = {
            place: 'tc',
            message: 'Invalid Credentials. Please try again.',
            type: 'danger',
            icon: "now-ui-icons ui-1_bell-53",
            autoDismiss: 7
        }; 

        store.setState({ notification });
        return;
    }
    console.log('NEW AUTH TOKEN', auth);
    window.localStorage.setItem('auth', JSON.stringify(auth));
    store.setState({ auth });
};
export const queryParamAuthToken = (store, tokenParam, expirationParam, emailParam, userParam) => {
    let auth = {
        token: tokenParam,
        expires: parseInt(expirationParam, 10),
        email: emailParam,
        user_id: userParam
    }
    if(auth.expires > Date.now() / 1000) {
        store.setState({ auth });
        store.actions.userActions.getUserMe();
        return true;
    }
    return false;
};
export const loadAuth = (store) => {
    const storedAuth = window.localStorage.getItem("auth");
    if(storedAuth !== null) {
      let auth = JSON.parse(storedAuth);
      if(auth.expires > Date.now() / 1000) {
        store.setState({ auth });
        store.actions.userActions.getUserMe();
        return true;
      }
    }
    return false;
}

export const logout = (store) => {
    window.localStorage.removeItem('auth');
    let auth = null;
    store.setState({ auth });
}

export const setAuth = (store, auth) => {
    store.setState({ auth });
}

export const resetPassword = async (store, data) => {
    const responseData = await apiClient.auth.resetPassword(data);
    const response = {
        type: "resetpassword",
        data: responseData
    }
    store.setState({ response });
}